<!-- AppMenu.vue -->
<template>
  <nav class="bg-stone-600 text-white">
    <!-- buton hamburger -->
    <div class="sm:hidden flex items-center justify-between p-4">
      <h2 class="text-lg font-bold">Menu</h2>
      <button @click="isOpen = !isOpen" class="focus:outline-none">
        <svg
          v-if="!isOpen"
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16" />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- lista de meniu -->
    <ul
      :class="[
        'sm:flex sm:space-x-4 sm:px-4',
        isOpen ? 'block' : 'hidden sm:flex',
      ]"
      class="bg-stone-600 sm:bg-stone-600"
    >
        <li class="p-3 hover:bg-gray-600 cursor-pointer">
            <router-link to="/" class="block w-full h-full">Home</router-link>
        </li>
        <li class="p-3 hover:bg-gray-600 cursor-pointer">
            <router-link to="/consumptions" class="block w-full h-full">Consumptions</router-link>
        </li>
        <li class="p-3 hover:bg-gray-600 cursor-pointer">
            <router-link to="/products" class="block w-full h-full">Products</router-link>
        </li>
        <li class="p-3 hover:bg-gray-600 cursor-pointer">
            <router-link to="/categories" class="block w-full h-full">Categories</router-link>
        </li>
        <li v-if="authStore.isAdmin === true" class="p-3 hover:bg-gray-600 cursor-pointer bg-red-800">
            <router-link to="/admin/users" class="block w-full h-full">Users</router-link>        
        </li>
    </ul>
  </nav>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useAuthStore } from "../stores/auth";
const authStore = useAuthStore();
const isOpen = ref(false);

onMounted(() => {
  console.log('😊', authStore.user, authStore.isAdmin)
})
</script>
